
export type LoginPageConfig = {
  title: string
  description?: string
  backTo?: string
  maxWidthClassName?: string
  contentClassName?: string
  headingClassName?: string
  descriptionClassName?: string
}

export const LOGIN_PAGE_CONFIG: Record<string, LoginPageConfig> = {
  "/login": {
    title: "店舗アカウントにログイン",
    contentClassName: "space-y-10",
  },
  "/login/forget-password": {
    title: "パスワードをお忘れの場合",
    backTo: "/login",
    description: "登録済みのメールアドレスにパスワード再設定用のメールを送信します",
  },
  "/login/forget-password/sent": {
    title: "再設定用のメールを送信しました",
    backTo: "/login/forget-password",
  },
  "/login/reset-password": {
    title: "パスワード再設定",
  },
}
